module.exports = __webpack_public_path__ + "img/Dantam Hair 17.e4f71a8e.jpg";